import { render } from "./contact.vue?vue&type=template&id=f7bb9f2c"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"
script.render = render

export default script